import keyMirror from 'keymirror';

// Todo: Move all these constants to ./proctor.js

// Refer: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#exceptions
export const webcamDomException = keyMirror({
  AbortError: null,
  NotAllowedError: null,
  NotFoundError: null,
  NotReadableError: null,
});

// Lodash template
export const webcamDomExceptionMessage = {
  [webcamDomException.AbortError]:
    'Your <%= webcamMicDisableText %> drivers are either not installed or not working properly. Please try re-installing the <%= webcamMicDisableText %> drivers.',
  [webcamDomException.NotAllowedError]:
    'Your browser is blocking the <%= webcamMicDisableText %>. Please enable the <%= webcamMicDisableText %> from your browser settings and try again.',
  [webcamDomException.NotFoundError]:
    'This device does not support the <%= webcamMicDisableText %> requirements for this <%= test_type_verbose %>. Please try taking the <%= test_type_verbose %> from another device.',
  [webcamDomException.NotReadableError]:
    'Your <%= webcamMicDisableText %> drivers are already used by another process / application. <%= secureBrowserWebcamError %>',
};

export const SECURE_BROWSER_WEBCAM_ERROR =
  'or enable the camera permissions from system settings and try again.';

export const webcamWaitingMessage = 'Waiting for webcam...';
export const webcamOrMicWaitingMessage = 'Waiting for webcam or mic...';

export const webcamDisabledMessageTitle = 'Webcam not detected';

export const videoConstraints = {
  width: 640,
  height: 480,
  facingMode: 'user',
};
